import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { DemoModeService } from '../demo/demo-mode.service';
import { TenantStore } from '../stores/tenant.store';

export const tenantAccessGuard: CanActivateFn = () => {
  if (inject(DemoModeService).active()) {
    return true;
  }

  if (!inject(TenantStore).accessDenied()) {
    return true;
  }

  return inject(Router).parseUrl('/no-access');
};
